/**
 * Post-call SMS constants shared between the sender (apps/api PostCallSmsService)
 * and the admin SMS follow-up settings card, so the UI shows the exact strings
 * that get sent.
 *
 * Templates run through `resolveVariables` ({{companyName}} / {{callTitle}}
 * handlebars-style placeholders), so they're plain strings here, not functions.
 */
/** Appended to a post-call SMS whose body doesn't already mention STOP. */
export const POST_CALL_SMS_OPT_OUT_SUFFIX = "Reply for more help, or say 'stop' to opt out.";
/**
 * Default inbound post-call SMS, sent when isSmsFollowUpEnabled is true and
 * smsFollowUpText is empty. Carries the opt-out language inline rather than as
 * a separate appended sentence, so appendOptOut is a no-op on this template.
 */
export const INBOUND_POST_CALL_SMS_TEMPLATE = `Thanks for calling {{companyName}} about "{{callTitle}}." We've logged your call. Feel free to reply for more help, or say 'stop' to opt out.`;
/**
 * Default outbound post-call SMS, sent when isSmsFollowUpEnabled is true and
 * smsFollowUpText is empty. Carries the opt-out language inline rather than as
 * a separate appended sentence, so appendOptOut is a no-op on this template.
 */
export const OUTBOUND_POST_CALL_SMS_TEMPLATE = `Hi, this is {{companyName}}. We just called regarding "{{callTitle}}." Please reply if you need further assistance, or say 'stop' to opt out.`;
const STANDALONE_STOP_PATTERN = /\bstop\b/i;
/**
 * Append the opt-out suffix unless the message already contains a standalone
 * "stop" (case-insensitive) — covers both a customer's custom smsFollowUpText
 * that already explains how to opt out, and the default templates above,
 * which already carry the opt-out language.
 */
export function appendOptOut(message) {
    const trimmed = message.trim();
    if (STANDALONE_STOP_PATTERN.test(trimmed))
        return trimmed;
    return `${trimmed} ${POST_CALL_SMS_OPT_OUT_SUFFIX}`;
}
//# sourceMappingURL=post-call-sms.js.map